import { keyBy } from 'lodash'
import { apiFetch } from 'utils/apiFetch'

export const serviceCenterDevicesGet = async () => {
  const devices = await apiFetch({ url: '/service-center-devices-get', body: null })

  return keyBy(devices, 'source')
}
